import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const vatNumberSection = css`
  margin: 0 ${spacing.lg}px ${spacing.xxxxl}px ${spacing.lg}px;

  p {
    font-family: ${fonts.PRIMARY_REGULAR.family};
    font-weight: ${fonts.PRIMARY_REGULAR.weight};
    ${responsiveText.BODY.SM};
  }
`;

export const divider = css`
  margin: 0 ${spacing.lg}px;
  border: none;
  height: 1px;
  background-color: var(--neutral-black-10);

  &:first-of-type {
    margin-bottom: ${spacing.xxl}px;
  }
`;
